import {
  Divider,
  ExternalLink,
  LayoutCard,
  Stack,
  Typography,
} from '@cast/design-system';
import {
  FreeFeaturesList,
  PaidFeaturesList,
  TrialFeaturesList,
} from '@cast/shared-trial-ui';
import { getDocsLink } from '@cast/utils';

export const TrialInfoCards = () => (
  <Stack direction="row" gap={16} data-testid="trial-info-cards" margin="auto">
    <LayoutCard title="Start a free trial" headerDivider sx={{ maxWidth: 420 }}>
      <Stack gap={16} py={12}>
        <Typography variant="P12M">
          Explore all available Cast AI premium features
        </Typography>
        <TrialFeaturesList />
        <Typography variant="P12M">
          Start using Cast AI right away with zero financial commitment or
          future obligations.
        </Typography>
      </Stack>
    </LayoutCard>

    <LayoutCard
      title="What happens to my clusters after free trial?"
      headerDivider
      sx={{ maxWidth: 420 }}
    >
      <Stack gap={16} py={12}>
        <Typography variant="P12R">
          A downgrading process will take place to transition your account back
          to a <strong>free version</strong>, ensuring your infrastructure is
          preserved. For more details,{' '}
          <ExternalLink link={getDocsLink('docs_trial')} noIcon>
            see our documentation
          </ExternalLink>
          .
        </Typography>
        <Stack gap={8}>
          <Typography variant="P12R">The free version includes:</Typography>
          <FreeFeaturesList />
        </Stack>
        <Divider />
        <PaidFeaturesList />
      </Stack>
    </LayoutCard>
  </Stack>
);
